//Laravel API 通信だけ担当
import axios from 'axios';
import { ensureCsrfCookie } from './axiosDefaults';

// 登録
export const register = async (userData) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/register`, userData);
  return response.data;
};
// SPAログイン（Cookie + CSRF）
export const spaLogin = async (userData) => {
  await ensureCsrfCookie();
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/spa/login`, userData);
  return response.data;
};

export const resendVerificationNotification = async (token) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/email/verification-notification/resend`, { token });
  return response.data;
};

// パスワード再設定リンク送信
export const forgotPassword = async (email) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/forgot-password`, { email });
  return response.data;
};

// パスワード再設定
export const resetPassword = async (payload) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/reset-password`, payload);
  return response.data;
};

// ログアウト
export const logout = async () => {
  // Cookie-session logout
  await ensureCsrfCookie();
  await axios.post(`${process.env.REACT_APP_API_URL}/spa/logout`, {});
};

// ログイン中ユーザー取得（認証確認用）
export const getUser = async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/user`);
  return response.data;
};
